export default __webpack_public_path__ + "static/carton2-a44fcb450743532023bc04d2c674682f.png";